import React from 'react';
import PropTypes from 'prop-types';
import { StyledH1, StyledH2, StyledH3, StyledH4, StyledText } from './index.styles';

export const H1 = StyledH1;
export const H2 = StyledH2;
export const H3 = StyledH3;
export const H4 = StyledH4;

export const Text = ({ children, ...otherProps }) => (
    <StyledText {...otherProps}>{children}</StyledText>
);

Text.propTypes = {
    large: PropTypes.bool,
    small: PropTypes.bool,
    weight: PropTypes.oneOf(['light', 'regular', 'medium', 'semiBold', 'bold']),
    children: PropTypes.node.isRequired,
};

Text.defaultProps = {
    large: false,
    small: false,
    weight: 'regular',
};

Text.Styles = {
    StyledText,
};
